import { Directive, HostBinding, Input } from '@angular/core';
import { NgModel } from '@angular/forms';
import { TextProps, textStyles } from '@kite_aerolab/shared/components';

@Directive({
  selector: '[kiteText]',
  providers: [NgModel],
})
export class TextDirective {
  /**
   * Tamaño del texto: small o extra small
   */
  @Input() size: TextProps['size'];
  /**
   * Alineación del texto
   */
  @Input() align: TextProps['align'];

  /**
   * Css del componente
   */
  @Input() css: TextProps['css'];
  /**
   * Variante (determina el color del texto)
   */
  @Input() variant: TextProps['variant'];
  /**
   * Variante (determina el color del texto)
   */
  @Input() weight: TextProps['weight'];

  @HostBinding('class')
  public get setClasses() {
    return textStyles({
      size: this.size,
      align: this.align,
      css: this.css,
      weight: this.weight,
      variant: this.variant,
    }).className;
  }
}
